<app-cv-nurse-template [isProduction]="isProduction" [mailServiceURL]="mailServiceURL" [showModal]="true" [nurse]="nurse"></app-cv-nurse-template>
